<template>
  <div id="Navigation" class="bg-white">
    <div class="content-container d-flex flex-row flex-nowrap justify-content-between align-items-center w-100 py-2">
        <img @click="$router.push('/gp')" alt="Bupa Logo" class="bupa-nav-logo clickable ml-2 ml-sm-0" src="/img/gp/bupa_logo.svg"
          onerror="javascript:this.src='/img/logo-spectrum-life.svg'" />
        <b-button variant="cta-outline" class="py-4 mr-2 mr-sm-0" squared size="lg" :href="getBupaTouchLink">Go back to My Bupa</b-button>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Navigation",
  data() {
    return {};
  },
  mounted() { },
  methods: {
    navigate(item) {
      if (!item.external_link) {
        if (item.asset_id) {
          this.$router.push({ name: item.item_slug, params: { id: item.asset_id } });
        } else {
          this.$router.push({ name: item.item_slug });
        }
      } else {
        window.open("https://" + item.external_link, "_blank");
      }
    },
  },
  computed: {
    ...mapGetters(["hardcoded", "skin", "client", "nav"]),
    currentPage() {
      return this.$route.name;
    },
    getBupaTouchLink() {
      if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'){
        return 'https://scsmoke3.np.bupa.co.uk/touchdashboard/dashboard/gp-options'
      }else{
        return 'https://www.bupa.co.uk/touchdashboard/dashboard/gp-options'
      }

    },
    getLogo() {
      if (this.hardcoded && this.hardcoded.client_logo) {
        return this.hardcoded.client_logo;
      } else if (this.skin === 8) {
        return "/img/boi/boi-logo-alt.png";
      } else return this.client.client_logo;
    },
  },
};
</script>
<style lang="less" >
#Navigation {
  height: 80px;
  max-height: 80px;

  .logo-col {
    display: flex;
    flex-grow: 1;
    max-width: 50%;
    padding-left: calc((100% - 1170px) / 2);

    .nav-logo {
      height: 100%;
      padding: 5px;
    }
  }

  .nav-container {
    max-width: 100%;
    margin: 0;
    border-bottom: 8px solid #e4e4e7;
  }

  .nav-col {
    flex-grow: 1;
    flex-shrink: 1;
    padding-right: calc((100% - 1170px) / 2);

    .nav-link {
      font-size: 1.6rem;
      padding-right: 25px;
    }

    .dropdown-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      font-size: 1.6rem;

      .dropdown-item-inner {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        flex-grow: 1;
        align-items: center;
      }

      .nav-arrow {
        opacity: 0;
      }

      &:hover {
        font-weight: bold;

        .nav-arrow {
          opacity: 1 !important;
        }
      }

      &:active {
        background-color: #dedede;
      }
    }

    ul.dropdown-menu {
      z-index: 10000;
      border-radius: 16px;
      padding: 0;

      overflow: hidden;
    }
  }

  .triangle-div {
    flex-shrink: 1;
    width: 80px !important;
    max-height: 80px !important;
    padding-left: 10px;
    border-style: solid;
    border-width: 80px 80px 0 0;
  }

  .triangle-div-overlap {
    position: relative;
    top: -80px;
    right: 10px;
    width: 80px;
    border-style: solid;
    border-width: 80px 80px 0 0;
    border-color: white transparent transparent transparent;
  }
  .bupa-nav-logo{
    max-height: 70px;
  }
}
</style>
